import keys from '@debbie/common/dist/cache/keys.js';
import { CreditorState } from '@debbie/common/dist/creditor/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as creditorsAPI from '@debbie/cortex/dist/api/creditors.js';
import { creditorsEntity, useCreditor, } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import AddressInput from '../AddressInput.js';
import EditIcon from '../Icons/Edit.js';
import { Badge, CopyToClipboard, Edit, EditReferenceId, Modal, SmallHeader, } from '../index.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import CreditorNotes from './CreditorNotes.js';
const CreditorInfo = (props) => {
    const { id } = props;
    const lang = useSelector((s) => s.lang);
    const creditorLoadable = useCreditor(id);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const [stateModalOpen, setStateModalOpen] = useState(false);
    const invalidateCreditor = () => {
        if (creditor) {
            q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
        }
    };
    const updateCreditorStateMutation = useMutation(async (state) => {
        await creditorsAPI.update(id, { state });
    }, {
        onSuccess: () => {
            invalidateCreditor();
            setStateModalOpen(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.creditor);
        },
    });
    const updateCreditorReferenceId = async (id) => {
        if (!creditor) {
            return;
        }
        await creditorsAPI.update(creditor.creditorId, {
            referenceId: id,
        });
        q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
    };
    const updateCreditorName = async (name) => {
        if (!creditor) {
            return;
        }
        if (!name) {
            return;
        }
        await creditorsAPI.update(creditor.creditorId, {
            name,
        });
        q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
    };
    const updateCreditorCentralRegisterId = async (centralRegisterId) => {
        if (!creditor) {
            return;
        }
        if (!centralRegisterId) {
            return;
        }
        await creditorsAPI.update(creditor.creditorId, {
            centralRegisterId,
        });
        q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
    };
    const updateCreditorVatRegistered = async (vatRegistered) => {
        if (!creditor) {
            return;
        }
        await creditorsAPI.update(creditor.creditorId, {
            vatRegistered,
        });
        q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
    };
    const updateCreditorAddressMutation = useMutation(async (address) => {
        await creditorsAPI.update(id, { address });
    }, {
        onSuccess: invalidateCreditor,
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.creditor);
        },
    });
    return (React.createElement("div", null, creditor ? (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(Badge, { onClick: () => setStateModalOpen(!stateModalOpen), style: { cursor: 'pointer', float: 'right' }, theme: creditor.state === CreditorState.Active
                        ? THEME.SUCCESS
                        : [CreditorState.Cancelled, CreditorState.Ceased].includes(creditor.state)
                            ? THEME.DANGEROUS
                            : THEME.SELECTED_BLUE },
                    lang.creditors.states[creditor.state],
                    " ",
                    React.createElement(EditIcon, null)),
                stateModalOpen && (React.createElement(Modal, { onToggle: () => setStateModalOpen(!stateModalOpen), header: lang.creditors.setCreditorState, maxWidth: "380px" }, [
                    CreditorState.Lead,
                    CreditorState.SignedOn,
                    CreditorState.Active,
                    CreditorState.Ceased,
                    CreditorState.Cancelled,
                ].map((state) => (React.createElement(StateSelect, { key: state, onClick: () => !updateCreditorStateMutation.isLoading &&
                        updateCreditorStateMutation.mutate(state), style: {
                        opacity: updateCreditorStateMutation.isLoading
                            ? 0.5
                            : 1,
                        cursor: updateCreditorStateMutation.isLoading
                            ? 'not-allowed'
                            : 'pointer',
                    } },
                    React.createElement(Badge, { key: state, theme: state === CreditorState.Active
                            ? THEME.SUCCESS
                            : [
                                CreditorState.Cancelled,
                                CreditorState.Ceased,
                            ].includes(state)
                                ? THEME.DANGEROUS
                                : THEME.SELECTED_BLUE }, lang.creditors.states[state]),
                    React.createElement("p", null, lang.creditorStateDescriptions[state])))))),
                React.createElement("small", { style: {
                        borderRight: '1px solid lightgrey',
                        paddingRight: '10px',
                        marginRight: '10px',
                    }, "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.creditors.createdAt }, moment(creditor.createdAt).format(THEME.DATE_FORMAT_LONG)),
                React.createElement("small", null,
                    React.createElement(CopyToClipboard, { text: creditor.id }, creditor.id),
                    React.createElement(EditReferenceId, { value: creditor.id, onUpdate: updateCreditorReferenceId, placeholder: lang.creditors.reference })),
                React.createElement(CreditorNameLine, null,
                    React.createElement(CreditorName, null, creditor.name),
                    React.createElement(Edit, { value: creditor.name, onUpdate: (val) => updateCreditorName(val), placeholder: lang.creditors.name }))),
            React.createElement(InlineDiv, null,
                creditor.isCompany
                    ? lang.creditors.company
                    : lang.creditors.person,
                ' ',
                creditor.centralRegisterId != null ? (React.createElement(CentralRegisterIdLine, null,
                    React.createElement("small", null,
                        " (",
                        creditor.centralRegisterId,
                        ")"))) : null,
                React.createElement(Edit, { value: creditor.centralRegisterId, onUpdate: (val) => updateCreditorCentralRegisterId(val), placeholder: lang.creditors.cvr }),
                creditor.isCompany ? (React.createElement(VatRegisteredLine, null,
                    React.createElement(Badge, { theme: creditor.vatRegistered ? '#333' : '#333' }, creditor.vatRegistered
                        ? `${lang.creditors.vatRegistered}`
                        : `${lang.creditors.notVatRegistered}`),
                    React.createElement(Edit, { boolValue: creditor.vatRegistered, isBool: true, onUpdate: (val) => updateCreditorVatRegistered(val), placeholder: lang.creditors.vatRegistered }))) : null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(AddressInput, { address: creditor?.address, onChange: (address) => updateCreditorAddressMutation.mutate(address), disabled: updateCreditorAddressMutation.isLoading }),
            React.createElement(SmallHeader, null, lang.creditors.mandates),
            React.createElement(CreditorNotes, { creditor: creditor })))) : (React.createElement(PlaceholderLoader, null))));
};
export default CreditorInfo;
const CreditorNameLine = styled.div `
  display: flex;
  align-items: flex-end;
  overflow-wrap: break-word;
`;
const CentralRegisterIdLine = styled.div `
  display: flex;
  margin-left: 5px;
`;
const VatRegisteredLine = styled.div `
  display: flex;
  margin-left: 5px;
  margin-right: 8px;
`;
const CreditorName = styled.h1 `
  margin: 0.5em 0;
  margin-right: 10px;
  font-size: 1.6em;
  max-width: 100%;
`;
const StateSelect = styled.div `
  margin: 5px 0;
  cursor: pointer;
  background-color: #e6e6e6;
  border-radius: 2px;
  padding: ${THEME.GRID_SPACING}px;

  &:hover {
    opacity: 0.8;
  }
`;
const InlineDiv = styled.div `
  display: inline-flex;
`;
//# sourceMappingURL=CreditorInfo.js.map